import React from 'react';
import { FileCheck, FileX, Star, Search, Shield, Zap, RefreshCw, Wifi, Tag } from 'lucide-react';
import { services } from '../mockData';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const iconMap = {
  FileCheck,
  FileX,
  Star,
  Search,
  Shield,
  Zap,
  RefreshCw,
  Wifi,
  Tag
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-700 hover:bg-blue-100">
            Unsere Leistungen
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Alles rund um Ihre <span className="text-blue-600">KFZ-Zulassung</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Von der Schnellzulassung bis zur Versicherungsberatung – wir bieten Ihnen einen kompletten Service aus einer Hand.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const isFeatured = service.featured;
            
            return (
              <Card 
                key={service.id} 
                className={`group hover:shadow-xl transition-all duration-300 border-2 cursor-pointer ${
                  isFeatured 
                    ? 'border-green-400 bg-gradient-to-br from-green-50 to-white ring-2 ring-green-200' 
                    : 'hover:border-blue-200'
                }`}
              >
                <CardHeader>
                  {isFeatured && (
                    <div className="mb-3">
                      <Badge className="bg-green-600 text-white hover:bg-green-600">
                        ⚡ NEU & BELIEBT
                      </Badge>
                    </div>
                  )}
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 transition-colors duration-300 ${
                    isFeatured 
                      ? 'bg-green-600 group-hover:bg-green-700' 
                      : 'bg-blue-100 group-hover:bg-blue-600'
                  }`}>
                    <IconComponent className={`w-7 h-7 transition-colors duration-300 ${
                      isFeatured 
                        ? 'text-white' 
                        : 'text-blue-600 group-hover:text-white'
                    }`} />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 mb-2">
                    {service.title}
                  </CardTitle>
                  <div className="flex items-baseline space-x-2">
                    <span className={`text-2xl font-bold ${
                      isFeatured ? 'text-green-600' : 'text-blue-600'
                    }`}>{service.price}</span>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <div className="inline-flex flex-col items-center justify-center space-y-2 bg-blue-50 px-6 py-4 rounded-xl">
            <div className="flex items-center space-x-2">
              <Shield className="w-5 h-5 text-blue-600" />
              <p className="text-sm font-medium text-gray-700">
                Alle Preise inkl. Bearbeitungsgebühren – keine versteckten Kosten
              </p>
            </div>
            <p className="text-xs text-gray-600">
              * Kennzeichen-Erstellung gegen Aufpreis möglich, falls Sie keine eigenen Kennzeichen mitbringen
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
